import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  HostListener,
  OnInit,
  OnDestroy,
  HostBinding,
  AfterViewInit,
  PLATFORM_ID,
  Inject,
  NgZone,
} from '@angular/core';
import {
  ImageLightboxService,
  ImageSizes,
} from './../services/image-lightbox.service';
import { isPlatformBrowser } from '@angular/common';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

export enum ImageFitOptions {
  clip = 'clip',
  crop = 'crop',
  scale = 'scale',
  max = 'max',
}

@Directive({
  selector: 'img[dsImage]',
})
export class ImageDirective
  implements OnInit, OnChanges, OnDestroy, AfterViewInit
{
  @Input()
  imageHandle: any;
  @Input()
  fileHandle: any;
  @Input()
  imageSize: any;
  @Input()
  lightbox: boolean;
  @Input()
  alt: string;
  @Input()
  preLoad: boolean;
  @Input()
  fitType: ImageFitOptions = ImageFitOptions.max;

  errorSrc = `data:image/png;base64,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`;

  private intersectionObserver: IntersectionObserver;
  private scrollSubscription: Subscription;
  private isLoaded: boolean;

  @HostBinding('style.cursor')
  get clickable() {
    return this.lightbox ? 'zoom-in' : null;
  }

  @HostListener('error')
  imgError() {
    this.element.nativeElement.src = this.errorSrc;
  }

  constructor(
    private element: ElementRef,
    private imageLightboxService: ImageLightboxService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.element.nativeElement.alt = this.alt || '';
    if (this.lightbox && this.imageHandle) {
      this.imageLightboxService.addImageToLightbox({
        id: this.imageHandle,
        imageHandle: this.imageHandle,
        label: this.alt,
      });
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.canUseIntersectionObserver()) {
        this.intersectionObserver = new IntersectionObserver((entries) =>
          this.checkForIntersection(entries)
        );
        this.intersectionObserver.observe(this.element.nativeElement);
      } else {
        if (this.isOnScreen()) {
          this.load();
          return;
        }
        this.ngZone.runOutsideAngular(() => {
          this.scrollSubscription = fromEvent(window, 'scroll')
            .pipe(debounceTime(50))
            .subscribe(() => {
              if (this.isOnScreen()) {
                this.ngZone.run(() => this.load());
              } else {
              }
            });
        });
      }
    }
  }

  ngOnChanges(changes: any) {
    if (
      (this.isLoaded || this.preLoad) &&
      (changes.imageHandle || changes.fileHandle)
    ) {
      this.element.nativeElement.src = this.getUrl();
    }
  }

  ngOnDestroy() {
    if (this.lightbox) {
      this.imageLightboxService.removeImageFromLightbox(this.imageHandle);
    }

    this.removeListeners();
  }

  @HostListener('click', ['$event'])
  openLightbox($event) {
    if (this.lightbox) {
      $event.preventDefault();
      $event.stopPropagation();
      this.imageLightboxService.openLightbox(this.imageHandle);
    }
  }

  private getUrl() {
    if (this.fileHandle) {
      return this.imageLightboxService.thumbnailForFileUrl(this.fileHandle);
    } else if (this.imageHandle) {
      return this.imageLightboxService.getUrl(
        this.imageHandle,
        ImageSizes[this.imageSize],
        this.fitType as any
      );
    } else {
      return this.errorSrc;
    }
  }

  public canUseIntersectionObserver(): boolean {
    return 'IntersectionObserver' in window;
  }

  private checkForIntersection(entries: Array<IntersectionObserverEntry>) {
    const isIntersecting = entries.reduce(
      (previous, current) =>
        previous ||
        (current.isIntersecting &&
          current.target === this.element.nativeElement),
      false
    );

    if (isIntersecting) {
      this.load();
      this.intersectionObserver.unobserve(this.element.nativeElement);
    }
  }

  private load() {
    this.element.nativeElement.src = this.getUrl();
    this.isLoaded = true;
    this.removeListeners();
  }

  private isOnScreen() {
    const scrollPosition =
      (window.scrollY || window.pageYOffset) +
      (document.documentElement.clientHeight || document.body.clientHeight);
    const topPosition = this.element.nativeElement.getBoundingClientRect().top;

    return topPosition <= scrollPosition;
  }

  private removeListeners() {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }

    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }
}
